// extracted by mini-css-extract-plugin
export default {"cls1":"SbVWVIlrlPgwWYI4O_uh","cls2":"alEkeuQyckoxCI1WW8kg SbVWVIlrlPgwWYI4O_uh"};